import * as services from '@services/bankAccount'
import * as types from '@types'

export default {
  state: {
    bankAccount: [
      { id: new Date().getUTCMilliseconds(), documentFiles: [] }
    ],
    systemFields: {},
    customFields: {}
  },

  getters: {
    isBankAccountStepEmpty: ({ systemFields, customFields }) =>
      !Object.keys({
        ...systemFields.bankAccounts || {},
        ...customFields.bankAccounts || {},
      }).length
  },

  mutations: {
    [types.EMPLOYEE_BANK]: (state, data) => {
      state.bankAccount = data.length ? data : state.bankAccount
    },

    [types.EMPLOYEE_ADD_BANK]: (state) => {
      state.bankAccount = [
        ...state.bankAccount,
        { id: new Date().getUTCMilliseconds(), files: [] }
      ]
    },

    [types.EMPLOYEE_SET_BANK]: (state, { data, id, previousId }) => {
      const index = state.bankAccount.findIndex(bank => bank.id === (previousId || id))

      if (index >= 0)
        state.bankAccount.splice(index, 1, { files: [], ...data })
      else
        state.bankAccount.push({ ...data })
    },

    [types.EMPLOYEE_SET_BANK_FILES]: (state, { id, files }) => {
      const bankAccount = state.bankAccount.find(bank => bank.id === id)

      if (!bankAccount)
        return

      bankAccount.documentFiles = [ ...files ]
    },

    [types.EMPLOYEE_DELETE_BANK]: (state, bankAccount) => {
      state.bankAccount = state.bankAccount.filter(({ id }) => id !== bankAccount.id)
    },

    [types.EMPLOYEE_BANK_CUSTOM_FIELDS]: (state, data) => {
      state.systemFields = { ...(data?.systemFields || {}) }
      state.customFields = { ...(data?.customFields || {}) }
    }
  },

  actions: {
    [types.EMPLOYEE_BANK_CUSTOM_FIELDS]: async ({ commit, getters, dispatch }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, data ] = await services.getSystemFields({ employeeId, companyId })

      if (!err) commit(types.EMPLOYEE_BANK_CUSTOM_FIELDS, data)
      else dispatch('FEEDBACKS_ADD', {
        type: 'error',
        message: 'Não foi possível carregar os campos bancários.'
      })

      return [ err, data ]
    },

    [types.EMPLOYEE_BANK]: async ({ getters, dispatch, commit }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId }
      const [ err, data ] = await services.getBankAccount(params)

      if (!err) commit(types.EMPLOYEE_BANK, data)

      await dispatch(types.EMPLOYEE_BANK_CUSTOM_FIELDS)

      return [ err, data ]
    },

    [types.EMPLOYEE_SET_BANK]: async ({ state, commit, getters }, data) => {
      const schema = state.customFields.bankAccounts || {}
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId, schema }
      const isCreating = typeof data?.id !== 'string'

      if (isCreating) {
        const [ err, bankAccount ] = await services.createBankAccount(data, params)

        if (!err) commit(types.EMPLOYEE_SET_BANK, { data: bankAccount, previousId: data?.id })

        return [ err, bankAccount ]
      }

      const [ err ] = await services.updateBankAccount(data, params)

      return [ err, data ]
    },

    [types.EMPLOYEE_SET_BANKS]: async ({ state, dispatch }, bankAccounts) => {
      if (!bankAccounts.length) return [ false, state.bankAccount ]

      const submitted = []
      const errors = []

      const results = await Promise.allSettled((bankAccounts || [])
        .map(data => dispatch(types.EMPLOYEE_SET_BANK, data))
      ).catch(err => errors.push(err))

      results.forEach(({ value: [ err, bank ] = [] }) => err
        ? errors.push(err)
        : submitted.push(bank)
      )

      if (!errors.length) await dispatch(types.EMPLOYEE_BANK)

      return [ errors, submitted ]
    },

    [types.EMPLOYEE_DELETE_BANK]: async ({ getters, commit, state }, bankAccount) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId }
      const [ err ] = await services.deleteBankAccount(bankAccount, params)

      if (!err) commit(types.EMPLOYEE_DELETE_BANK, bankAccount)

      const hasNoBankAccounts = !state.bankAccount?.length

      if (hasNoBankAccounts) commit(types.EMPLOYEE_ADD_BANK)

      return [ err, null ]
    },

    [types.EMPLOYEE_BANK_UPLOAD_FILES]: async ({ getters }, { id, files }) => {
      const employeeId = getters.getEmployeeUuid
      const params = { id, files, employeeId }
      const [ err, data ] = await services.uploadBankAccountFiles(params)

      if (err) return [ err, [] ]

      return [ err, data ]
    }
  }
}
